import React from "react";
import App from "./App";
import { Provider } from "react-redux";
import Store from "./store";
import "./index.css";
import { createRoot } from "react-dom/client";
import { Toast } from "@appsmith/ads";
import "tailwindcss/tailwind.css";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element #root was not found");
}

const root = createRoot(container);

root.render(
  <Provider store={Store}>
    <Toast
      autoClose={5000}
      closeButton={false}
      draggable={false}
      hideProgressBar
      pauseOnHover={false}
    />
    <App />
  </Provider>,
);
